<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid"/> Inactive Health Policies
      </CCardHeader>
      <PoliciesTable />
    </CCard> 
  </div>
</template>

<script>
import PoliciesTable from "@/components/InactiveHealthTable"
export default {
  components:{
    PoliciesTable
  }
}
</script>

<style>

</style>